const errorMessages = {
    invalidName: 'Invalid name format.',
    invalidPhoneNumber: 'Invalid phone number format.',
    invalidEmail: 'Invalid email id format.',

};

export default errorMessages;
